import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";

function VerticalSlider({ product, onImageSelect }) {
    console.log("Product Details : ",product)
    const { configUrl } = useSelector((state) => state.cart);
    console.log("configUrl : ",configUrl)
    const settings = {
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 3,
        speed: 500,
        infinite: false,
        arrows: true,
        prevArrow: (
            <button 
                style={{
                    backgroundColor: "transparent", 
                    border: "none", 
                    fontSize: "24px", 
                    position: "absolute", 
                    top: "10px",
                    left: "50%", 
                    zIndex: 0, 
                    transform: "translateX(-50%)",
                    cursor: "pointer",
                }}
            >
                ▲
            </button>
        ),
        nextArrow: (
            <button 
                style={{
                    backgroundColor: "transparent", 
                    border: "none", 
                    fontSize: "24px", 
                    position: "absolute", 
                    bottom: "10px", 
                    left: "50%", 
                    zIndex: 0, 
                    transform: "translateX(-50%)",
                    cursor: "pointer",
                }}
            >
                ▼
            </button>
        ),
    };

    return (
        <div className='verticalSlider-container' style={{maxHeight: "86vh", position: "relative",width:"180px",
        overflowY: "hidden",overflowX: "scroll",borderRadius:"15px" }}>
            <div className=" product-detail-media" style={{height: "80vh",width:"100%" }}>
                <div style={{ margin: "0 auto", height: "100%", position: "relative",width:"100%" }}> 
                    <Slider {...settings} style={{height: "100%",width:"100%"}}>
                        
                        {product?.gallery?.map((image, index) => (
                            <div key={index} style={{ padding: "10px", height: "90%",zIndex:0,border:"1px solid black" }}>
                                <img
                                    src={`${configUrl}${image.image}`}
                                    alt={image.alt || `Product view ${index}`}
                                    style={{ width: "100%", cursor: "pointer",overflow:"hidden" }}
                                    onClick={() => onImageSelect(`${configUrl}${image.image}`)}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default VerticalSlider;
